"use strict";

module.exports = function () {
	try {
		Object.keys("primitive");
		return true;
	} catch (e) {
		return false;
	}
};



//////////////////
// WEBPACK FOOTER
// /~/es5-ext/object/keys/is-implemented.js
// module id = 2015
// module chunks = 0